module.exports = __webpack_public_path__ + "static/media/SAFESTOS.ff5b57b6.jpg";